export const blockAttendeeAccountStyle = {
	wrapper: {
		display: 'flex',
		padding: '16px',
		justifyContent: 'space-between',
		borderRadius: 'var(--default--border-radius)',
		border: '1px solid var(--neutral-100)',
		backgroundColor: 'var(--neutral-50)',
	},

	content: {
		display: 'flex',
		padding: '16px',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderRadius: 'var(--default--border-radius)',
		border: '1px solid var(--neutral-100)',
		backgroundColor: 'var(--neutral-50)',
		marginTop: '24px',

		'@media (max-width: 639.98px)': {
			display: 'none',
		},

		'@media (min-width: 1200px)': {
			display: 'none',
		},
	},

	title: {
		maxWidth: '776px',
		width: '100%',

		'& .MuiTypography-body2': {
			fontWeight: 400,
			color: 'var(--neutral-500)',
		},
	},

	button: {
		maxWidth: '174px',
		width: '100%',
		padding: '10px 16px',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 200px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '48px 120px',
			},

			'@media (max-width: 639.98px)': {
				padding: '40px 20px 20px',
			},
		},
	},
};
